/*https://codepen.io/danilonovakovic/pen/bxmWVM */
/* shorthand functions (createElement is defined at bottom)*/
const div = (props, ...children) => createElement('div', props, ...children);
const ul = (props, ...children) => createElement('ul', props, ...children);
const li = (props, ...children) => createElement('li', props, ...children);
const i = (props, ...children) => createElement('i', props, ...children);
const span = (props, ...children) => createElement('span', props, ...children);
const header = (props, ...children) => createElement('header', props, ...children);
const p = (props, ...children) => createElement('p', props, ...children);
const section = (props, ...children) => createElement('section', props, ...children);
const button = (props, ...children) => createElement('button', props, ...children);

/* File */

const File = props => {
  var name = props.name;
  var deletable = props.deletable;
  var deleteIcon = '';
  if (deletable) {
    deleteIcon = i({ className: 'file-delete-icon material-icons' }, 'delete');
  }

  var icon = props.icon;
  var fileIcon = icon ? i({ className: 'material-icons' }, icon) : '';
  return div(
    { className: 'file' },
    i({ className: 'material-icons file-status-icon', 'aria-hidden': 'true' }, ''),
    fileIcon,
    deleteIcon,
    span({ className: 'file-name' }, name)
  );
};

/* Folder */

const openedFolderIcon = 'folder_open';
const closedFolderIcon = 'folder';
const openedArrowIcon = 'arrow_drop_down';
const closedArrowIcon = 'arrow_right';

function changeOpened(event) {
  const folderHeader = event.target.classList.contains('folder-header')
    ? event.target
    : event.target.parentElement;
  const opened = folderHeader.getAttribute('opened') == 'true';
  const newOpened = !opened;

  let icons = folderHeader.querySelectorAll('.material-icons');
  icons.forEach(icon => {
    if (/arrow/i.test(icon.textContent)) {
      icon.textContent = newOpened ? openedArrowIcon : closedArrowIcon;
    } else {
      icon.textContent = newOpened ? openedFolderIcon : closedFolderIcon;
    }
  });

  try {
    const sibling = folderHeader.nextElementSibling;
    if (newOpened) {
      sibling.classList.remove('hide');
    } else {
      sibling.classList.add('hide');
    }
  } catch (e) {
    console.warn(`No sibling of elem ${folderHeader} found ...`);
  }

  folderHeader.setAttribute('opened', newOpened);
}

const Folder = (props, ...children) => {
  const opened = props.opened || false;
  const arrowIcon = opened ? openedArrowIcon : closedArrowIcon;
  const folderIcon = opened ? openedFolderIcon : closedFolderIcon;
  const folderName = props.name || 'unknown';

  return div(
    { className: 'folder' },
    header(
      {
        onClick: changeOpened,
        className: 'folder-header',
        opened: opened
      },
      i({ className: 'material-icons' }, arrowIcon),
      i({ className: 'material-icons' }, folderIcon),
      span(null, folderName)
    ),
    ul({ className: opened ? '' : 'hide' }, ...children)
  );
};

/* TreeView */

const TreeView = () => {
  return section(
    { className: 'container' },
    Folder(
      { name: 'src' },
      Folder({ name: 'myTest.js' }, File({ name: 'whatup.js' })),
      File({ name: 'justASimpleFile.css' })
    ),
    File({ name: 'project.json' })
  );
};

// const app = document.querySelector("#treeView");
// app.appendChild(createElement(TreeView));

function mapToFoldersAndFiles(dataTree, fileIcon, deletable) {
  // data is a nested dict of keys (folders) with filenames as leaves
  // returns a list of nested Folders and File objects
  var foldersAndFiles = [];
  for (var key in dataTree) {
    if (dataTree.hasOwnProperty(key)) {
      if (typeof dataTree[key] === 'object') {
        foldersAndFiles.push(Folder({ name: key }, mapToFoldersAndFiles(dataTree[key])));
      } else {
        foldersAndFiles.push(File({ name: key, icon: fileIcon, deletable: deletable }));
      }
    }
  }
  return foldersAndFiles;
}

function createTreeViewHelper(dataTree, fileIcon, deletable) {
  // data is a dict of keys with filenames as leaves
  // returns a treeview element
  var foldersAndFiles = mapToFoldersAndFiles(dataTree, fileIcon, deletable);
  return section({ className: 'container' }, ...foldersAndFiles);
}

const createTreeView = (data, parentSelector, fileIcon, deletable, folders = []) => {
  if (typeof deletable === 'undefined') {
    deletable = true;
  }
  // data is urls of files
  var file_ui_names = data; // data.map((x) => x.indexOf("-") > -1 ? x.slice(x.indexOf("-") + 1) : x)
  var parent = document.querySelector(parentSelector);

  // Exit early if parent element doesn't exist
  if (!parent) {
    console.warn(`TreeView parent element not found: ${parentSelector}`);
    return;
  }

  // data is names and urls of files
  // names can include folders in them which need processing
  // parent is the parent element to append to
  // returns the parent element
  var dataTree = {};
  // add folders first
  for (var i = 0; i < folders.length; i++) {
    var folderParts = folders[i].replace(/\/+$/, '').split('/');
    var current = dataTree;
    for (var j = 0; j < folderParts.length; j++) {
      current[folderParts[j]] = current[folderParts[j]] || {};
      current = current[folderParts[j]];
    }
  }

  for (var i = 0; i < file_ui_names.length; i++) {
    var parts = file_ui_names[i].split('/');
    var current = dataTree;
    for (var j = 0; j < parts.length; j++) {
      if (j === parts.length - 1) {
        current[parts[j]] = file_ui_names[i];
      } else {
        current[parts[j]] = current[parts[j]] || {};
        current = current[parts[j]];
      }
    }
  }
  var treeView = createTreeViewHelper(dataTree, fileIcon, deletable);
  // children
  parent.innerHTML = ''; // clear all // todo fix upload files
  parent.appendChild(createElement(() => treeView));
};

// Expose for legacy callers that reference a global `createTreeView`
try {
  const globalObj =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof window !== 'undefined'
        ? window
        : undefined;
  if (globalObj) {
    globalObj.createTreeView = createTreeView;
  }
} catch (e) {
  // no-op
}
/* My react-clone mini library */

function appendChildren(parent, children) {
  for (let child of children) {
    if (!child) continue;
    switch (typeof child) {
      case 'string':
        const el = document.createTextNode(child);
        parent.appendChild(el);
        break;
      default:
        parent.appendChild(child);
        break;
    }
  }
}
function setStyle(el, style) {
  if (typeof style == 'string') {
    el.setAttribute('style', style);
  } else {
    Object.assign(el.style, style);
  }
}
function setClass(el, className) {
  className.split(/\s/).forEach(element => {
    if (element) {
      el.classList.add(element);
    }
  });
}
function setProps(el, props) {
  const eventRegex = /^on([a-z]+)$/i;
  for (let propName in props) {
    if (!propName) continue;

    if (propName === 'style') {
      setStyle(el, props[propName]);
    } else if (propName === 'className') {
      setClass(el, props[propName]);
    } else if (eventRegex.test(propName)) {
      const eventToListen = propName.replace(eventRegex, '$1').toLowerCase();
      el.addEventListener(eventToListen, props[propName]);
    } else {
      el.setAttribute(propName, props[propName]);
    }
  }
}

//type, [props], [...children]
function createElement(type, props, ...children) {
  if (typeof type === 'function') {
    return type(props);
  } else {
    const el = document.createElement(type);
    if (props && typeof props === 'object') {
      setProps(el, props);
    }
    if (children) {
      appendChildren(el, children);
    }
    return el;
  }
}
